const SAVE_BOOKMARK_ON_CACHE = 'SAVE_BOOKMARK_ON_CACHE';
const EDIT_BOOKMARK_NAME = 'EDIT_BOOKMARK_NAME';
const EDIT_BOOKMARK_STATE = 'EDIT_BOOKMARK_STATE';
const CLEAR_BOOKMARKS_UNSAVED = 'CLEAR_BOOKMARKS_UNSAVED';


export const saveBookmarkOnCache = (bookmarks, bookmark) => ({
    type: SAVE_BOOKMARK_ON_CACHE,
    bookmarks,
    bookmark
});

export const editBookmarkName = (bookmarks, id, name) => ({
    type: EDIT_BOOKMARK_NAME,
    bookmarks,
    id,
    name
});

export const editBookmarkState = (bookmarks, id) => ({
    type: EDIT_BOOKMARK_STATE,
    bookmarks,
    id
});

export const clearBookmarksUnsaved = bookmarks => ({
    type: CLEAR_BOOKMARKS_UNSAVED,
    bookmarks
});

const saveNewBookmark = (bookmarks, newBookmark) => {
    bookmarks.unshift({...newBookmark, saved: true});

    return bookmarks;
};

const getBookmarksClearly = bookmarks => bookmarks.filter(bookmark => bookmark.saved === true);

const getEditName = (bookmarks, id, name) => {
    const ret = [];

    bookmarks.forEach(bookmark => {
        if (bookmark.id === id) {
            ret.push({
                ...bookmark,
                name
            });
        } else {
            ret.push(bookmark);
        }
    });

    return ret;
};

const getNewState = (bookmarks, id) => {
    const ret = [];

    bookmarks.forEach(bookmark => {
        if (bookmark.id === id) {
            ret.push({
                ...bookmark,
                saved: !bookmark.saved
            });
        } else {
            ret.push(bookmark);
        }
    });

    return ret;
};


// Reducer
const _defaultState = () => ({
    savedBookmarks: []
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SAVE_BOOKMARK_ON_CACHE:
        return {
            ...state,
            savedBookmarks: saveNewBookmark(action.bookmarks, action.bookmark)
        };
    case EDIT_BOOKMARK_NAME:
        return {
            ...state,
            savedBookmarks: getEditName(action.bookmarks, action.id, action.name)
        };
    case EDIT_BOOKMARK_STATE:
        return {
            ...state,
            savedBookmarks: getNewState(action.bookmarks, action.id)
        };
    case CLEAR_BOOKMARKS_UNSAVED:
        return {
            ...state,
            savedBookmarks: getBookmarksClearly(action.bookmarks)
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cloudBillingPersists.js